import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnMiddle, mixinResetBtnCss, mixinBtnCancel, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";

interface IProps
    extends IBtnDefaultProps, React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

const BtnCancelMiddleDefault: React.FC<IProps> = (props) => {

    const {  icon, widthSize, ...ButtonProps } = props;

    return (<button {...ButtonProps} />)

};

const BtnCancelMiddle = styled(BtnCancelMiddleDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnMiddle}
    ${mixinBtnCancel}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnCancelMiddle;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_cancel_middle.tsx